import type { MessageChannelV3 } from "@redotech/redo-flows-common/rules-v3/types";

/** Display names for the channels an agent can be assigned tickets on. */
export const channelLabels: Record<MessageChannelV3, string> = {
  gmail: "Gmail",
  outlook: "Outlook",
  customEmail: "Email",
  redoChat: "Redo Chat",
  facebook: "Facebook",
  facebookComments: "Facebook comments",
  instagram: "Instagram",
  instagramComments: "Instagram comments",
  sms: "SMS",
  voice: "Voice",
  attentive: "Attentive",
  postscript: "Postscript",
  tiktok: "TikTok",
  contactForm: "Contact form",
};

/** The connected channels an agent can be assigned; `null` means every channel. */
export function resolveAssignableChannels(
  assignableChannels: readonly string[] | null,
  connectedChannels: readonly MessageChannelV3[],
): readonly MessageChannelV3[] | null {
  if (assignableChannels === null) {
    return null;
  }
  return connectedChannels.filter((channel) =>
    assignableChannels.includes(channel),
  );
}

export function describeAssignableChannels(
  assignableChannels: readonly string[] | null,
  connectedChannels: readonly MessageChannelV3[],
): string {
  const resolved = resolveAssignableChannels(
    assignableChannels,
    connectedChannels,
  );
  if (resolved === null) {
    return "All channels";
  }
  const labels = resolved.map((channel) => channelLabels[channel]);
  return labels.length === 0 ? "No channels" : labels.join(", ");
}
